export const DEFAULT_MAP_STYLE = {
  type: {
    space: { color: '#F7F7F7', outline: '#B0B0B0' },
    object: { color: '#F7F7F7' },
  },
  programType: {
    WORK: { color: '#f0f8fa' },
    MEET: { color: '#D8D8D8', outline: '#cccccc' },
  },
  subType: {
    HALLWAY: { color: '#ebebeb', outline: undefined },
    CHAIR: { color: '#d4d4d4', outline: '#969696' },
    TABLE: { color: '#f4f6f6', outline: '#969696' },

    // CHAIR: { color: '#f4f6f6' },
    // TABLE: { color: '#d4d4d4' },
    'DEDICATED DESK': { color: '#ebebeb' },
    'DEDICATED DESKS': { color: '#ebebeb' },
    'SHARED OFFICE DESK': { color: '#ebebeb' },
    'SHARED OFFICE DESKS': { color: '#ebebeb' },
    'HOT DESK': { color: '#f0f8fa' },
    'HOT DESKS': { color: '#f0f8fa' },
    'HOT DESK AREA': { color: '#f0f8fa' },
    'HOT DESKS AREA': { color: '#f0f8fa' },
    'PRIVATE HOT DESK AREA': { color: '#f0f8fa' },
    'PRIVATE HOT DESKS AREA': { color: '#f0f8fa' },
  },
}

export const INTERNAL_ROOMS_MAP_STYLE = {
  type: {
    space: { color: '#e2e2e2', outline: '#cccccc' },
    object: { color: '#e2e2e2' },
  },
  programType: {
    WORK: { color: '#B2DFFF', outline: '#003C66' },
    MEET: { color: '#D8D8D8', outline: '#cccccc' },
  },
  subType: {
    HALLWAY: { color: '#ebebeb', outline: undefined },
    CHAIR: { color: '#d4d4d4', outline: '#969696' },
    TABLE: { color: '#f4f6f6', outline: '#969696' },
    // CHAIR: { color: '#f4f6f6' },
    // TABLE: { color: '#d4d4d4' },
    'DEDICATED DESKS': { color: '#B2DFFF', outline: '#003C66' },
    'SHARED OFFICE DESK': { color: '#B2DFFF', outline: '#003C66' },
    'SHARED OFFICE DESKS': { color: '#B2DFFF', outline: '#003C66' },
    'HOT DESKS': { color: '#B2DFFF', outline: '#003C66' },
    'HOT DESK AREA': { color: '#B2DFFF', outline: '#003C66' },
    'HOT DESKS AREA': { color: '#B2DFFF', outline: '#003C66' },
    'PRIVATE HOT DESK AREA': { color: '#B2DFFF', outline: '#003C66' },
    'PRIVATE HOT DESKS AREA': { color: '#B2DFFF', outline: '#003C66' },
  },
}

export const DEFAULT_THEME = {
  overrides: {
    // Name of the component / style sheet
    MuiButton: {
      // Name of the rule
      text: {
        // Some CSS
        fontSize: '1rem',
        fontWeight: 500,
        textTransform: 'initial',
      },
      contained: {
        textTransform: 'initial',
        fontWeight: 500,
      },
    },
  },
  palette: {
    primary: {
      main: '#6772e5',
    },
  },
}
